<template>
  <div>
    <h1 class="vi-section-title">Insights</h1>

    <b-row v-if="temDados">
      <b-col
        v-for="(items, categoria) in consumos"
        :key="categoria"
        cols="12"
        md="6"
        xl="6"
        class="mb-3"
      >
        <div class="vi-consumo-card">
          <div class="vi-consumo-header">
            <h2 class="vi-consumo-title text-capitalize">
              Top {{ categoria }}
            </h2>
          </div>

          <div v-if="items.length">
            <div
              v-for="(item, index) in visibleItems(categoria)"
              :key="index"
              class="vi-consumo-item"
            >
              <div class="vi-consumo-info">
                <div class="vi-consumo-name-row">
                  <span class="vi-consumo-name">{{ item.name }}</span>
                  <span class="vi-consumo-pct">{{ item.progress }}%</span>
                </div>
                <div class="vi-bar-wrap">
                  <div
                    class="vi-bar"
                    :style="{ width: item.progress + '%' }"
                  ></div>
                </div>
                <span class="vi-consumo-meta">
                  {{ item.unidades_vendidas }} unidades ·
                  {{ item.total_pago.toFixed(2) }} €
                </span>
              </div>
            </div>

            <!-- Paginação -->
            <div v-if="items.length > pageSize" class="vi-consumo-pag">
              <button
                class="vi-pag-btn"
                :disabled="!canGoPrev(categoria)"
                @click="prevPage(categoria)"
              >
                ‹
              </button>
              <span class="vi-pag-info">
                {{ pageByCategoria[categoria] || 1 }} /
                {{ Math.ceil(items.length / pageSize) }}
              </span>
              <button
                class="vi-pag-btn"
                :disabled="!canGoNext(categoria)"
                @click="nextPage(categoria)"
              >
                ›
              </button>
            </div>
          </div>

          <div v-else class="vi-empty">Sem dados a mostrar</div>
        </div>
      </b-col>
    </b-row>

    <div v-else class="vi-empty-state">
      <svg
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#d0c8c0"
        stroke-width="1.5"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
      <h4>Nenhum dado disponível</h4>
      <p>Não foram encontrados consumos para os filtros aplicados.</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "InsightsConsumos",
    props: {
      consumos: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        pageByCategoria: {},
        pageSize: 5,
      };
    },
    computed: {
      temDados() {
        return Object.values(this.consumos).some((arr) => arr.length > 0);
      },
    },
    methods: {
      visibleItems(categoria) {
        const page = (this.pageByCategoria[categoria] || 1) - 1;
        const start = page * this.pageSize;
        return (this.consumos[categoria] || []).slice(
          start,
          start + this.pageSize,
        );
      },
      canGoPrev(categoria) {
        return (this.pageByCategoria[categoria] || 1) > 1;
      },
      canGoNext(categoria) {
        const page = this.pageByCategoria[categoria] || 1;
        return page * this.pageSize < (this.consumos[categoria] || []).length;
      },
      prevPage(categoria) {
        if (this.canGoPrev(categoria)) {
          this.$set(
            this.pageByCategoria,
            categoria,
            (this.pageByCategoria[categoria] || 1) - 1,
          );
        }
      },
      nextPage(categoria) {
        if (this.canGoNext(categoria)) {
          this.$set(
            this.pageByCategoria,
            categoria,
            (this.pageByCategoria[categoria] || 1) + 1,
          );
        }
      },
    },
  };
</script>

<style scoped>
  .vi-section-title {
    font-size: 18px;
    font-weight: 800;
    color: #1a1210;
    letter-spacing: -0.3px;
    margin: 0 0 14px;
  }
  .vi-consumo-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }
  .vi-consumo-header {
    padding: 14px 20px;
    border-bottom: 1px solid #f5f2ef;
  }
  .vi-consumo-title {
    font-size: 14px !important;
    font-weight: 800 !important;
    color: #ff825d !important;
    margin: 0 !important;
  }
  .vi-consumo-item {
    padding: 12px 20px;
    border-bottom: 1px solid #faf8f6;
    transition: background 0.08s;
  }
  .vi-consumo-item:last-of-type {
    border-bottom: none;
  }
  .vi-consumo-item:hover {
    background: #fdfcfb;
  }
  .vi-consumo-name-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 5px;
  }
  .vi-consumo-name {
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1210;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 75%;
  }
  .vi-consumo-pct {
    font-size: 13px;
    font-weight: 700;
    color: #ff825d;
    flex-shrink: 0;
  }
  .vi-bar-wrap {
    height: 4px;
    background: #f0ece8;
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 5px;
  }
  .vi-bar {
    height: 100%;
    background: #ff825d;
    border-radius: 2px;
    transition: width 0.3s;
  }
  .vi-consumo-meta {
    font-size: 11.5px;
    color: #b0a8a0;
  }
  .vi-consumo-pag {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 10px 20px;
    border-top: 1px solid #f5f2ef;
  }
  .vi-pag-btn {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    border: 1.5px solid #e8e4e0;
    background: #fff;
    font-size: 16px;
    color: #6b6460;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.12s;
    line-height: 1;
  }
  .vi-pag-btn:hover:not(:disabled) {
    border-color: #ff825d;
    color: #ff825d;
  }
  .vi-pag-btn:disabled {
    opacity: 0.3;
    cursor: default;
  }
  .vi-pag-info {
    font-size: 12px;
    color: #b0a8a0;
    font-weight: 600;
  }
  .vi-empty {
    text-align: center;
    padding: 40px 20px;
    color: #b0a8a0;
    font-size: 13.5px;
    font-style: italic;
  }
  .vi-empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #b0a8a0;
  }
  .vi-empty-state h4 {
    font-size: 16px;
    font-weight: 700;
    color: #5a534f;
    margin: 16px 0 6px;
  }
  .vi-empty-state p {
    font-size: 13.5px;
    margin: 0;
  }
</style>
